var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon48PxHuman(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3372_103054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 46.2863C36.3088 46.2863 46.2863 36.3088 46.2863 24.0005C46.2863 11.6925 36.3088 1.71484 24.0005 1.71484C11.6925 1.71484 1.71484 11.6925 1.71484 24.0005C1.71484 36.3088 11.6925 46.2863 24.0005 46.2863Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0016 24.0012C27.5362 24.0012 30.4016 21.1358 30.4016 17.6012C30.4016 14.0666 27.5362 11.2012 24.0016 11.2012C20.4669 11.2012 17.6016 14.0666 17.6016 17.6012C17.6016 21.1358 20.4669 24.0012 24.0016 24.0012Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60156 40.0004C11.1064 37.0688 13.2215 34.6458 15.7433 32.9649C18.2652 31.2834 21.109 30.4004 24.0015 30.4004C26.894 30.4004 29.7379 31.2834 32.2597 32.9649C34.7817 34.6458 36.8965 37.0688 38.4016 40.0004",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3372_103054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon48PxHuman);
export default __webpack_public_path__ + "static/media/icon_48px_human.aeb95d3333762f77c9858099b640e19d.svg";
export { ForwardRef as ReactComponent };